'use client';
import { CommonButton } from '@components/common-button/CommonButton';
import linkArrow from '@images/svg/linkArrow.svg';
import { fetchFlats } from '@lib/store/slices/FilterSlice';
import { SafeHtmlRenderer } from '@lib/tools/helpers/SafeHtmlRenderer';
import dynamic from 'next/dynamic';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import sectionStyle from '../../section.module.scss';
import style from '../page.module.scss';

const MortgageCalculatorFinch = dynamic(() => import('@components/calculator/NewCalculator'));

export const MortgageClient = ({ specialMortgages, calcData, isMobile, mortgageGroupOptions, children }) => {
  const dispatch = useDispatch();
  const flatsData = useSelector(state => state?.filters?.flatsData);
  const calculatorName = useSelector(state => state.projectinfo.mortgageCalculatorName);

  const existCalculator = calculatorName !== null;

  const calcRef = useRef(null);

  const scrollToCalc = () => {
    const xPosition = calcRef.current.offsetTop;

    window.scrollTo({
      top: xPosition,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    if (!flatsData || !flatsData.flats) {
      dispatch(fetchFlats({ withProcessing: false }));
    }
  }, [flatsData]);

  return (
    <>
      <section className={sectionStyle.section_terms}>
        <div className={sectionStyle.section_titles}>
          <p className={sectionStyle.section_title}>
            Специальные <br />
            программы
          </p>
          {existCalculator && (
            <CommonButton
              className={style.scrollButton}
              handleFunction={scrollToCalc}
              text='Калькулятор ипотеки'
              icon={linkArrow}
            />
          )}
        </div>
        <div className={sectionStyle.section_contents}>
          {specialMortgages.description.map((mortgage, i, row) => {
            return (
              <div key={mortgage?.item}>
                <div className={sectionStyle.section_content}>
                  <SafeHtmlRenderer tag='p' className={sectionStyle.terms_title} content={mortgage.title || ''} />
                  <SafeHtmlRenderer tag='div' className={sectionStyle.terms_desc} content={mortgage.item || ''} />
                </div>
                {i + 1 !== row.length && !isMobile && <div className={sectionStyle.terms_line} />}
              </div>
            );
          })}
        </div>
      </section>

      {existCalculator && (
        <section className={style.section_calculator} ref={calcRef}>
          {!isMobile && <p className={style.section_title}>Калькулятор ипотеки</p>}
          {calculatorName && (
            <MortgageCalculatorFinch calcData={calcData} mortgageGroupOptions={mortgageGroupOptions} />
          )}
        </section>
      )}

      {children}
    </>
  );
};
